import { TextField, TextFieldProps } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import styles from './form.module.scss';
type ITextInputRHFProps = Omit<TextFieldProps, 'name'> & {
  name: string;
  label?: string;
  errorMessageClassName?: string;
  hideErrorMessage?: boolean;
};

function TextInputRHF(props: ITextInputRHFProps) {
  const { name, hideErrorMessage = true, errorMessageClassName } = props;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const errorTxt = (errors[name]?.message as string) ?? null;
  const hasError = Boolean(errorTxt);

  const errorCss = [styles.errorMessage];
  errorMessageClassName && errorCss.push(errorMessageClassName);

  return (
    <div>
      <TextField
        {...props}
        {...register(name)}
        error={hasError}
        InputLabelProps={{ ...props.InputLabelProps, shrink: true }}
      />
      {errorTxt && !hideErrorMessage && (
        <p className={errorCss.join(' ')}>{errorTxt}</p>
      )}
    </div>
  );
}

export default TextInputRHF;
